import { api } from 'src/services/api';
import { useMutation } from '@tanstack/react-query';
import { Appointment } from 'src/models';
import { useAppointmentListClient } from './useGetAppointmentList';
import { useAppointmentDetailsClient } from './useGetAppointmentDetails';

export type UseMuteAppointmentNotificationPayload = {
  appt_uuid: Appointment['appt_uuid'];
  is_opt_out: boolean;
};
export const useOptOutAppointmentNotification = () => {
  const { scanAppointment } = useAppointmentListClient();
  const { scanAppointment: scanAppointmentDetails } =
    useAppointmentDetailsClient();
  return useMutation({
    mutationKey: ['optOutAppointmentNotification'],
    mutationFn: ({
      appt_uuid,
      is_opt_out,
    }: UseMuteAppointmentNotificationPayload) => {
      return api.put(`/opt_out_appointment/${appt_uuid}`, {
        is_opt_out,
      });
    },
    onSuccess: (_, { appt_uuid, is_opt_out }) => {
      scanAppointment(appt_uuid, (appointment) => ({
        ...appointment,
        is_opted_out: is_opt_out,
      }));
      scanAppointmentDetails(appt_uuid, (appointment) => ({
        ...appointment,
        is_opted_out: is_opt_out,
      }));
    },
  });
};
